/**
 * The presentation manifest. Switch modules on or off here; the scene sequence, progress map,
 * counter, presenter cues, transitions and docs/SCRIPT.md all follow automatically.
 *
 * In development, `?modules=mint,mint-it,carbonmove` limits the portfolio for a rehearsal
 * without editing this file (see resolveConfig in registry.ts).
 */
export interface PresentationConfig {
  modules: {
    intro: boolean;
    mint: { enabled: boolean; specialisations: { it: boolean; travel: boolean; business: boolean } };
    ecosystem: boolean;
    researchSpace: { enabled: boolean };
    /** Moderta Native, placed immediately after Research Space (owner decision 2026-10-10). */
    native: { enabled: boolean };
    carbonMove: { enabled: boolean };
    climateViewPoint: { enabled: boolean };
    eTrust: { enabled: boolean; priority: 'secondary' };
    sharedCapabilities: boolean;
    /** Optional reflective scenes. Off by default. */
    technology: boolean;
    process: boolean;
    future: boolean;
    closing: boolean;
  };
}

export const presentationConfig: PresentationConfig = {
  modules: {
    intro: true,
    mint: { enabled: true, specialisations: { it: true, travel: true, business: true } },
    ecosystem: true,
    researchSpace: { enabled: true },
    native: { enabled: true },
    carbonMove: { enabled: true },
    climateViewPoint: { enabled: true },
    eTrust: { enabled: true, priority: 'secondary' },
    sharedCapabilities: true,
    technology: false,
    process: false,
    future: true,
    closing: true,
  },
};
